import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { NbEvaIconsModule } from '@nebular/eva-icons';
import {
  NbDatepickerModule,
  NbDialogModule,
  NbGlobalPhysicalPosition,
  NbLayoutModule,
  NbMenuModule,
  NbOverlayModule,
  NbSidebarModule,
  NbThemeModule,
  NbTimepickerModule,
  NbToastrModule,
  NbWindowModule
} from '@nebular/theme';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { provideStore } from '@ngxs/store';
import { ENVIRONMENT } from 'src/environments/environment';
import { RouterState } from './features/auth/redux';
import { CampaignState } from './features/campaigns/redux';
import { ContentState } from './features/content/redux';
import { DrbState } from './features/drbs/redux';
import { InsightsState } from './features/insights/redux';
import { CleanScoreState } from './features/qa-testing/clean-score/redux';
import { QaState } from './features/qa-testing/redux';
import { RobotFamilyMetadataState } from './features/robot-family-metadata/redux';
import { SurveysState } from './features/surveys/redux';
import { ROUTES } from './shared/constants/route-constants';
import { SpinnerState } from './shared/ui/spinner/redux/spinner.state';

export const appConfig: ApplicationConfig = {
  providers: [
    provideStore(
      [
        InsightsState,
        ContentState,
        SurveysState,
        CampaignState,
        DrbState,
        QaState,
        CleanScoreState,
        RobotFamilyMetadataState,
        RouterState,
        SpinnerState
      ],
      {
        developmentMode: !ENVIRONMENT.isProduction,
        selectorOptions: { suppressErrors: true }
      }
    ),
    provideRouter(ROUTES),
    importProvidersFrom(
      NbEvaIconsModule,
      BrowserModule,
      NbMenuModule.forRoot(),
      NbToastrModule.forRoot({
        position: NbGlobalPhysicalPosition.BOTTOM_LEFT
      }),
      NbDatepickerModule.forRoot(),
      NbDialogModule.forRoot(),
      NbWindowModule.forRoot(),
      NbTimepickerModule.forRoot(),
      NbOverlayModule.forRoot(),
      NbSidebarModule.forRoot(),
      NbLayoutModule,
      NgxsReduxDevtoolsPluginModule.forRoot({ name: 'Insight Engine UI' })
    ),
    provideAnimations(),
    NbThemeModule.forRoot().providers
  ]
};
